import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";
import auth from "./modules/auth";
import home from "./modules/home";
import profile from "./modules/profile";
import landing from "./modules/landing";
import appAlert from "./plugins/appAlert";
import confirmation from "./plugins/confirmtion";
import listener from "@/mixin/listener";
import loader from "./plugins/loader";
import router from "./router";
import { filters } from "./utils";
import VueTelInputVuetify from "vue-tel-input-vuetify/lib";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import { appUrl, environment } from "@/environment";

Vue.config.productionTip = false;

window.Event = new Vue();

const options = {
  store,
  router,
};

Vue.use(appAlert);
Vue.use(confirmation);
Vue.use(loader);
Vue.use(Toast);
Vue.use(auth, options);
Vue.use(home, options);
Vue.use(profile, options);
Vue.use(landing, options);

Sentry.init({
  Vue,
  dsn: "https://6c284440bae616f46f7cf1f7979afb51@o75405.ingest.us.sentry.io/4510141755817984",
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: [environment, appUrl, /^\//],
    }),
  ],
  // sampleRate: adjust for performance monitoring
  tracesSampleRate: 1.0,
  sendDefaultPii: true,
});

Vue.use(VueTelInputVuetify, {
  vuetify,
});

/* Register Filters */
filters.forEach((f) => {
  Vue.filter(f.name, f.execute);
});

new Vue({
  vuetify,
  store,
  router,
  mixins: [listener],
  render: (h) => h(App),
}).$mount("#app");
